import React, { useEffect, useState } from 'react';
import ContainerHeader from 'components/ContainerHeader/index';
import API from 'util/V3Api';
import ActionsTable from 'components/ActionsTable'
import CardBox from 'components/CardBox';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Slide,Typography } from '@material-ui/core';
import { LinearProgress as LinearProgres } from "@material-ui/core";
import SnackBar from 'components/SnackBar';
import VideoPlayer from './VideoPlayer';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
});
const Camera = (props) => {

    const [snackBar,setSnackBar] = useState({snackOpen:false,snackMessage:'',snackType:'error'});
    const [loading, setLoading] = useState(false);
    const [dialog, setDialog] = useState({open:false, fullWidth:true, content:null, header:'', agreeBtnTxt:'', disAgreeBtnTxt:'', disableSubmit:false, type:'', callback:null});



    const handleDialogClose = ()=>{
        setDialog({
            open:false,
            content:'',
            header:'',
            agreeBtnTxt:'',
            disAgreeBtnTxt:'',
            type:'',
            location:null,
            callback:null
        });
    }
    const getCameraFeed = ()=>{
        setLoading(true);
        API.get('streamUrl').then(res=>{
            setDialog({
                open:true,
                header: 'Camera Feed',
                disAgreeBtnTxt:'Cancel',
                src : res.data.data.url
            });
        }).catch(err=>{
            setSnackBar({
                open: true,
                message: 'Unable to get the Video Stream',
                type: "error",
            })          
        }).finally(()=>{
            setLoading(false);
        });
    }
    return(
        <>
            <ContainerHeader title="Camera" match={props.match}/>
            <Button  variant="outlined"  color="primary" onClick={getCameraFeed}>Open Feed</Button>
            { loading &&  <div className='w-100 mt-3'><LinearProgres color="primary" /></div> }

            <Dialog
				open={dialog.open}
				TransitionComponent={Transition}
				keepMounted
				fullWidth
				maxWidth='md'
				onClose={handleDialogClose}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<LinearProgress style={{visibility:props.showProgress ? 'visible' : 'hidden'}} color="primary" />
				<DialogTitle id="alert-dialog-slide-title" sx={{ borderBottom: "1px solid red" }} style={{ textAlign: "center" }}>{dialog.header}</DialogTitle>
				<DialogContent className='d-flex justify-content-center align-items-center flex-column'>
                    <VideoPlayer
                        src={dialog?.src}
                    />
                </DialogContent>

				<DialogActions>
					{dialog.submitBtnLabel && 
						<Button variant="outlined"  color="primary" onClick={() => { dialog.callback(dialog.userData)}} disabled={dialog.disableSubmit} > {dialog.submitBtnLabel} </Button>}						
					<Button variant="outlined"  color="secondary" onClick={handleDialogClose}> Close</Button>
				</DialogActions>
			</Dialog>
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar({ open: false, message: "" });
                }}
            />
        </>
    )
}

export default Camera;